module.exports = __webpack_public_path__ + "img/abg1.3e3a367e.png";